import _padStart from 'lodash/padStart';

import getCardInfo from './getCardInfo';

function formatCardNumber(number, mask) {
  return number
    .match(/.{1,4}|^$/g)
    .join(' ')
    .replace(/x/g, mask);
}

function formatExpirationDate(expMonth, expYear) {
  if (expMonth && expYear) {
    const year = expYear.length === 4 ? expYear.substr(2, 2) : expYear;

    return `${_padStart(expMonth, 2, '0')}/${year}`;
  }

  return '';
}

export default function preparePaymentCardsData(paymentCards = [], mask) {
  const date = new Date();

  return paymentCards
    .filter((card) => card.status === 'IsActive')
    .map((card) => {
      const cardMask = card.cardMask || card.cardNumber || card.number || card.initialValue;
      const { cardNumber, ...restInfo } = getCardInfo(cardMask);

      const { expMonth, expYear, expired } = card;
      const expiresSoon = date >= new Date(expYear, parseInt(expMonth, 10) - 3); // предупреждаем за 2 месяца

      let expirationDate;
      if (expired || expiresSoon) {
        expirationDate = formatExpirationDate(expMonth, expYear);
      }

      return {
        cardNumber: formatCardNumber(cardNumber, mask),
        cardHolder: card.cardHolder,
        id: card.cardId,
        expired,
        expiresSoon,
        expirationDate,
        disabled: expired,
        isVirtualCard: card.isVirtualCard,
        ...restInfo,
      };
    });
}
